import { render, staticRenderFns } from "./DATE.vue?vue&type=template&id=f1a19fdc&"
import script from "./DATE.vue?vue&type=script&lang=js&"
export * from "./DATE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports